var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultImageSettings01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Default Image Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.87,21.71a4.26,4.26,0,0,1-4.33-4.08,4.37,4.37,0,0,1,4.15-4.32A4.36,4.36,0,0,1,24,17.44,4.26,4.26,0,0,1,19.87,21.71Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.44,34.5q-6-6-11.64-12.3c-1.5-1.66-2.52-1.48-3.88.08-3,3.35-6,6.62-9,9.92-2.79,3-3.07,3-6.06.32-.69-.62-1.42-1.2-2-1.87-1.32-1.43-2.47-1.35-3.88,0-3,2.87-6.2,5.62-9.25,8.47"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.1,
    y: 8.07,
    width: 46.88,
    height: 36.69,
    rx: 5.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.79,47.91l-.35,2.25A4.64,4.64,0,0,1,38.14,54L8.27,49.28A4.64,4.64,0,0,1,4.41,44L7,27.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImageSettings01);
export default __webpack_public_path__ + "static/media/Default_Image_Settings_01.70a9a1f8ee9391ac27a6e8aa1310e44b.svg";
export { ForwardRef as ReactComponent };